import { useState } from "react";
import WalletSetupDialog from "./WalletSetupDialog";

/** Inline prompt for payment flows when the user has no Kost wallet yet. */
const NoWalletNotice = ({ onCreated }: { onCreated: () => void }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="mb-2 p-3 rounded-lg border border-dashed border-primary text-sm">
        You don't have a wallet yet.{" "}
        <button
          className="text-primary font-semibold"
          onClick={() => setOpen(true)}
        >
          Set one up
        </button>
      </div>
      <WalletSetupDialog
        isOpen={open}
        onClose={() => setOpen(false)}
        onCreated={() => {
          setOpen(false);
          onCreated();
        }}
      />
    </>
  );
};

export default NoWalletNotice;
